'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSelectAll = function MdSelectAll(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 15v10h10v-10h-10z m-3.4 13.4v-16.8h16.8v16.8h-16.8z m13.4-20v-3.4h3.4v3.4h-3.4z m0 26.6v-3.4h3.4v3.4h-3.4z m6.6-6.6v-3.4h3.4v3.4h-3.4z m0-13.4v-3.4h3.4v3.4h-3.4z m0 20v-3.4h3.4c0 1.8-1.6 3.4-3.4 3.4z m0-13.4v-3.2h3.4v3.2h-3.4z m-13.2 13.4v-3.4h3.2v3.4h-3.2z m-3.4-30v3.4h-3.4v-3.4h3.4z m-10 23.4v-3.4h3.4v3.4h-3.4z m3.4 6.6c-1.8 0-3.4-1.6-3.4-3.4h3.4v3.4z m23.2-30c1.8 0 3.4 1.6 3.4 3.4h-3.4v-3.4z m-10 0v3.4h-3.2v-3.4h3.2z m-16.6 10v-3.4h3.4v3.4h-3.4z m6.6 20v-3.4h3.4v3.4h-3.4z m-6.6-13.4v-3.2h3.4v3.2h-3.4z m0-13.2c0-1.8 1.6-3.4 3.4-3.4v3.4h-3.4z' })
        )
    );
};

exports.default = MdSelectAll;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/select-all.js
// module id = 1880
// module chunks = 168707334958949